import { Link } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";
import { BLOG, blogUrl } from "@/data/site";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";

const fmt = (d) => new Date(d).toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });

export default function Blog() {
  return (
    <>
      <SEO
        title="Blog | Dicas de Desentupimento — Desentupidora Paulistana"
        description="Dicas, preços e orientações sobre desentupimento em São Paulo: como evitar entupimentos, custos de hidrojateamento, emergências e mais."
        path="/blog"
      />
      <section className="bg-brand-black text-white">
        <div className="max-w-7xl mx-auto container-px py-14">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Blog" }]} />
          <h1 className="font-display font-black text-4xl sm:text-5xl mt-4 mb-3">Blog</h1>
          <p className="text-gray-300 max-w-2xl">Dicas práticas, preços e orientações para você cuidar das tubulações do seu imóvel.</p>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-7xl mx-auto container-px py-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {BLOG.map((p) => (
            <article key={p.slug} className="group flex flex-col bg-white rounded-lg overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.06)] hover:shadow-[0_12px_36px_rgba(0,0,0,0.12)] transition-all hover:-translate-y-1" data-testid={`blog-card-${p.slug}`}>
              <div className="relative h-48 overflow-hidden">
                <span className="absolute top-3 left-3 z-10 bg-brand-red text-white text-[11px] font-bold uppercase px-3 py-1 rounded">{p.category}</span>
                <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="flex items-center gap-1.5 text-xs text-gray-400 mb-2"><Calendar className="w-3.5 h-3.5" /> {fmt(p.date)}</span>
                <h2 className="font-display font-bold text-lg text-brand-black mb-2 leading-snug">{p.title}</h2>
                <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-1">{p.excerpt}</p>
                <Link to={blogUrl(p.slug)} className="inline-flex items-center gap-1.5 text-brand-red font-bold text-sm hover:gap-2.5 transition-all" data-testid={`blog-read-${p.slug}`}>
                  Ler artigo <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
